import React, { useState, useEffect, Fragment } from 'react';
import { Button, Card, Col, Row, FormCheck, Modal, ListGroup } from 'react-bootstrap';
import { Accordion, AccordionDetails, AccordionSummary, Autocomplete, TextField } from '@mui/material';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { Input } from 'reactstrap';
import toastAlert from '../../../js/Base/ToastAlert';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import CloseIcon from '@mui/icons-material/Close';
import { ExpandMore } from '@mui/icons-material';
import { useSelector } from "react-redux";
import {
  getProjectRolesByProjectId,
  getProjectMemberByProjectMemberId,
  createProjectMemberApi,
  updateProjectMemberRole
} from '../../../api/projectApi';

const ProjectMemberEditModal = ({ isModalOpen, handleClose, submitEffect, isCreate, projectMember, companyMemberList }) => {
  const [memberList, setMemberList] = useState([]);
  const [joinDt, setJoinDt] = useState(new Date());
  const [selectedRoleNoList, setSelectedRoleNoList] = useState([]);
  const [selectedCompanyMember, setSelectedCompanyMember] = useState(null);
  const [roleList, setRoleList] = useState([]);
  const [flowzaListGroup, setFlowzaListGroup] = useState([]);
  const [isClick, setIsClick] = useState(true);
  const { email, isAdmin } = useSelector(state => state.user);

  const [initialValues, setInitialValues] = useState({
    name: "",
    email: "",
    phone: "",
    timezone: "",
  });

  useEffect(() => {
    if (isModalOpen && isCreate) {
      resetForm();
    }
  }, [isModalOpen, isCreate]);

  const resetForm = () => {
    setSelectedCompanyMember(null);
    setSelectedRoleNoList([]);
    setInitialValues({
      name: "",
      email: "",
      phone: "",
      timezone: "",
    });
    setJoinDt(new Date());
  };

  // Members List
  useEffect(() => {
    if (projectMember) {
      getProjectmemByPmid();
    }
  }, [isCreate, projectMember]);

  // 抓取專案角色清單
  useEffect(() => {
    const loadRoles = async () => {
      const projectUuid = localStorage.getItem("project_uuid");
      const userName = localStorage.getItem('user_email');
      const projectMemberUuid = projectMember?.uuid;
    
      if (!projectUuid) return;
      try {
        const res = await getProjectRolesByProjectId({
          acct_email: userName,
          project_uuid: projectUuid,
          project_member_uuid: projectMemberUuid,
        });
    
        const data = res.data;
        if (!data.success) {
          toastAlert.autoClose(true).showError("發生錯誤，請稍後再試");
          return;
        }

        const roleList = Array.isArray(data.roleList) ? data.roleList : [];

        // 非 Admin 不顯示 eDC Admin
        const filteredRoles = isAdmin
          ? roleList
          : roleList.filter(r => r.name !== "eDC Admin");

        setRoleList(filteredRoles);
    
        // 編輯模式：帶入既有角色
        if (!isCreate && data.member_role_list?.length > 0) {
          const selectedRoles = roleList.filter((r) =>
            data.member_role_list.some(
              (mr) => Number(mr.role_no) === Number(r.id)
            )
          );
          setSelectedRoleNoList(selectedRoles);
        } else {
          setSelectedRoleNoList([]);
        }

      } catch (error) {
        if (error.__handled) return;
        toastAlert.autoClose(true).showError("發生錯誤，請稍後再試");
      }
    };
  
    if (isModalOpen) {
      resetForm();
      loadRoles();
    }
  }, [isModalOpen, isCreate, projectMember]);
  
  const getProjectmemByPmid = async () => {
    if (!projectMember?.uuid) return;

    try {
      const res = await getProjectMemberByProjectMemberId(projectMember.uuid);
      const data = res.data;
  
      if (data.success && data.member) {
        setInitialValues({
          name: data.member.name,
          email: data.member.email,
          phone: data.member.phone,
        });
      }
    } catch (error) {
      if (error.__handled) return;
      toastAlert.autoClose(true).showError("發生錯誤，請稍後再試");
    }
  };

  const datePickerOnChange = (val) => {
    setJoinDt(val)
  };


  const createProjectMember = async () => {
    if (!selectedCompanyMember) {
      toastAlert.autoClose(true).showError("請選擇公司成員");
      return;
    }
    const projectUuid = localStorage.getItem("project_uuid");
    const roleUuidList = selectedRoleNoList.map((r) => r.uuid);
    const joinDtFormatted = joinDt ? joinDt.toISOString() : null;

    try {
      const payload = {
        project_uuid: projectUuid,
        company_member_uuid: selectedCompanyMember.uuid,
        role_uuid_list: roleUuidList,
        join_dt: joinDtFormatted,
      };
    
      const res = await createProjectMemberApi(payload);
      const data = res.data;

      if (data.success) {
        toastAlert.autoClose(true).showSuccess("新增成功");
        resetForm();
        handleClose();
        if (submitEffect) submitEffect();
      } else {
        toastAlert.autoClose(true).showError("新增失敗，請稍後再試");
      }
    } catch (error) {
      if (error.__handled) return;
      toastAlert.autoClose(true).showError("新增失敗，請稍後再試");
    }
  };

  const editProjectMember = async () => {
    if (!projectMember) return;

    const roleUuidList = selectedRoleNoList.map((r) => r.uuid);
    const originRoleNoList = projectMember?.member_role_list?.map((r) => r.role_no) || [];

    try {
      const payload = {
        project_member_uuid: projectMember.uuid,
        role_uuid_list: roleUuidList,
      };
    
      const res = await updateProjectMemberRole(payload);
      const data = res.data;

      if (data.success) {
        toastAlert.autoClose(true).showSuccess("更新成功");
        resetForm();
        handleClose();
        if (submitEffect) submitEffect();
      } else {
        toastAlert.autoClose(true).showError("更新失敗");
      }
    } catch (error) {
      if (error.__handled) return;
      toastAlert.autoClose(true).showError("更新失敗，請稍後再試");
    }
  };

  const submitForm = async () => {
    if (isCreate) {
      await createProjectMember();
    } else {
      await editProjectMember();
    }
  };


  return (
    <>
      <Modal
        animation="true"
        style={{ zIndex: '8999' }}
        show={isModalOpen}
        onHide={() => {
          resetForm();
          handleClose();
        }}
        className="ProjectManagement"
      >
        <Modal.Header>
          <Modal.Title style={{ fontSize: '16px', fontWeight: 'bold', }}>{isCreate ? '新增人員' : '編輯人員'}</Modal.Title>
        
          {/* 解決籃框問題，自訂MUI按鈕 */}
          <button
            onClick={handleClose}
            style={{
              background: 'transparent',
              border: 'none',
              cursor: 'pointer',
              padding: 0,
              marginLeft: 'auto'
            }}
          >
            <CloseIcon fontSize="medium" />
          </button>
        </Modal.Header>
          <Modal.Body className="modal-body" style={{ padding: '24px' }}>
            <Row>
              {/* 上方資訊輸入欄位 */}
              <Col md="12" className="mb-4" style={{ padding: '0px' }}>
                <Accordion
                  defaultExpanded
                  style={{ paddingRight: '0px', paddingLeft: '0px', boxShadow: 'None', border: '1px solid #E2E2E2' }}
                >
                  <AccordionSummary expandIcon={<ExpandMore style={{ color: '#E2E2E2' }} />}>
                    {!isCreate? '基本資訊':'公司成員'}
                  </AccordionSummary>
                  <AccordionDetails style={{ border: '1px solid #E2E2E2', borderLeft: 'None', borderRight: 'None', padding: '0px' }}>
                    <ListGroup variant="flush">
                      {isCreate && (
                        <>
                          <ListGroup.Item>
                            <Input
                              type="select"
                              id="member"
                              value={selectedCompanyMember ? selectedCompanyMember.account.id : 0}
                              onChange={(e) => {
                                const selectedId = Number(e.target.value);
                                if (selectedId === 0) {
                                  setSelectedCompanyMember(null);
                                  setInitialValues({ name: "", email: "", phone: "", timezone: "" });
                                  return;
                                }
                                const member = companyMemberList.find((item) => item.account.id === selectedId);
                                setSelectedCompanyMember(member);
                                if (member) {
                                  setInitialValues({
                                    name: member.account.name,
                                    email: member.account.email,
                                    phone: member.account.phone || "",
                                    timezone: member.account.timezone || "",
                                  });
                                }
                              }}
                            >
                              <option key={0} value={0}>
                                請選擇公司成員
                              </option>
                              {companyMemberList.map((item) => (
                                <option key={item.account.id} value={item.account.id}>
                                  {`姓名: ${item.account.name}  帳號: ${item.account.email}`}
                                </option>
                              ))}
                            </Input>
                          </ListGroup.Item>

                          <ListGroup.Item style={{ height: "50px", display: "flex", alignItems: "center" }}>
                            <Col md={2}>加入日期</Col>
                            <Col md={10}>
                              <DatePicker
                                className="form-control"
                                name="join_dt"
                                selected={(joinDt && new Date(joinDt)) || null}
                                onChange={(val) => {
                                  datePickerOnChange(val);
                                }}
                                timeInputLabel="Time:"
                                dateFormat="yyyy-MM-dd HH:mm"
                                showTimeInput
                              />
                            </Col>
                          </ListGroup.Item>
                        </>
                      )}

                      {/* 上方資訊顯示欄位 */}
                      <ListGroup.Item style={{ height: '50px', display: 'flex', alignItems: 'center' }}>
                        <Col md={2}>姓名</Col>
                        <Col md={10}>{initialValues.name}</Col>
                      </ListGroup.Item>
                      <ListGroup.Item style={{ height: '50px', display: 'flex', alignItems: 'center' }}>
                        <Col md={2}>帳號</Col>
                        <Col md={10}>{initialValues.email}</Col>
                      </ListGroup.Item>
                      <ListGroup.Item style={{ height: '50px', display: 'flex', alignItems: 'center' }}>
                        <Col md={2}>電話</Col>
                        <Col md={10}>{initialValues.phone}</Col>
                      </ListGroup.Item>
                    </ListGroup>
                  </AccordionDetails>
                </Accordion>
              </Col>

              {/* 下方顯則角色欄位 */}
              <Col md="12" style={{ padding: '0px' }}>
                <Accordion
                  defaultExpanded
                  style={{ paddingRight: '0px', paddingLeft: '0px', boxShadow: 'None', border: '1px solid #E2E2E2' }}
                >
                  <AccordionSummary expandIcon={<ExpandMore style={{ color: '#E2E2E2' }} />}>
                    專案角色
                  </AccordionSummary>
                  <AccordionDetails style={{ border: '1px solid #E2E2E2', borderLeft: 'None', borderRight: 'None', padding: '0px' }}>
                    <ListGroup>
                      {roleList.length > 0 && (
                        <ListGroup.Item style={{ height: 'auto', display: 'flex', alignItems: 'center' }}>
                          <Autocomplete
                            id="role-autocomplete"
                            multiple
                            size="small"
                            disablePortal
                            options={roleList}
                            getOptionLabel={(option) => option?.name || ""}
                            isOptionEqualToValue={(option, value) => Number(option.id) === Number(value.id)}
                            onChange={(event, newValue) => setSelectedRoleNoList(newValue)}
                            value={selectedRoleNoList}
                            sx={{
                              width: '100%',
                              '& .MuiOutlinedInput-root': {
                                backgroundColor: '#FFFFFF',
                                fontSize: '13px',
                              },
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                placeholder={selectedRoleNoList.length === 0 ? "請選擇角色" : ""}
                                variant="outlined"
                                fullWidth
                              />
                            )}
                            PopperProps={{
                              sx: {
                                zIndex: 2000,
                              },
                            }}
                          />
                        </ListGroup.Item>
                      )}
                    </ListGroup>
                  </AccordionDetails>
                </Accordion>
              </Col>
            </Row>
          </Modal.Body>

          <Modal.Footer className="modal-footer">
            <Button
              type="button"
              className="btn btn-cancel"
              onClick={() => {
                resetForm();
                handleClose();
              }}
            >
              取消
            </Button>
            <Button
              type="button"
              className="btn btn-custom"
              onClick={submitForm}
            >
              確認
            </Button>
          </Modal.Footer>
      </Modal>
    </>
  );
};

export default ProjectMemberEditModal;
